import React from 'react'

import {
  ShoppingBasketAdd,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function AddIcon() {
  return <ShoppingBasketAdd width="24" height="24" />
}

export default AddIcon
